export const CACHE_KEY = 'cachedProdutos';
